'use client';

import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import JournalHeader from './components/JournalHeader';
import MetricsBentoGrid from './components/MetricsBentoGrid';
import EquityCurveChart from './components/EquityCurveChart';
import PnlByStrategyChart from './components/PnlByStrategyChart';
import TradeLogTable from './components/TradeLogTable';

export default function TradingJournalPage() {
  const [showFilters, setShowFilters] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleFilterToggle = () => setShowFilters((v) => !v);
  const handleRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <AppLayout>
      <div className="pt-14 lg:pt-0 min-h-screen bg-background">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-12 py-6 space-y-6">
          <JournalHeader
            showFilters={showFilters}
            onFilterToggle={handleFilterToggle}
            onRefresh={handleRefresh}
            onTradeLogged={handleRefresh}
          />
          <MetricsBentoGrid />
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
            <div className="xl:col-span-2">
              <EquityCurveChart />
            </div>
            <div className="xl:col-span-1">
              <PnlByStrategyChart />
            </div>
          </div>
          <TradeLogTable
            showFilters={showFilters}
            onFilterToggle={handleFilterToggle}
            refreshKey={refreshKey}
          />
        </div>
      </div>
    </AppLayout>
  );
}